import { render } from "./PurchaseItem.vue?vue&type=template&id=69baafe4"
import script from "./PurchaseItem.vue?vue&type=script&lang=js"
export * from "./PurchaseItem.vue?vue&type=script&lang=js"

import "./PurchaseItem.vue?vue&type=style&index=0&id=69baafe4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__